<template>
  <header id="applicationHeader__mobile" :class="headerClass">
    <div class="container-fluid">
      <EntiteServicielle
        class="bloc-entite-servicielle-clir-sm justify-content-start d-flex flex-fill"
        :blocMarqueConfig="blocMarqueConfig"
        :logoConfig="logoConfig"
      >
        <template v-slot:customBlocLogotype>
          <slot #customBlocLogotype></slot>
        </template>
      </EntiteServicielle>
        <MenuToggler @toggleMenu="toggleMenu" />
        <div
          :id="navId"
          :class="toggleMenuClass"
          class="navbar-collapse position-relative w-100 m-0 top-0 border-gray-400"
        >
          <BlocPrive
            :headerClass="headerClass"
            :disconnectConfig="disconnectConfig"
            :profilConfig="profilConfig"
            :searchConfig="searchConfig"
            :customConnectedButtons="customConnectedButtons"
            :connectConfig="connectConfig"
            v-on="$listeners"
          />
          <hr class="bg-gray-400" />
          <ApplicationMenu id="applicationMenuMobile" :config="menuConfig" />
        </div>
    </div>
  </header>
</template>

      
<script>
import EntiteServicielle from "./Common/EntiteServicielle";
import BlocPrive from "./Mobile/BlocPrive";
import MenuToggler from "./MobileTablet/MenuToggler";
import ApplicationMenu from "./Mobile/ApplicationMenu";

import ApplicationMenuConfig from "@clir/ApplicationMenu/ApplicationMenuConfig";

import generateUid from "@/clir/utils/generateUid/";
const selectorId = "nav" + generateUid();

export default {
  name: "ApplicationHeaderMobile",
  data() {
    return { navId: selectorId, showMenu: false };
  },
  computed: {
    toggleMenuClass() {
      return this.showMenu ? "" : "d-none";
    }
  },
  watch: {
    $route() {
      this.showMenu = false;
    }
  },
  props: {
    menuConfig: { type: Object, default: () => ApplicationMenuConfig },
    headerClass: { type: String, default: "" },
    blocMarqueConfig: { type: Object, default: () => {} },
    logoConfig: { type: Object, default: () => {} },
    customConnectedButtons: { type: Array, default: () => [] },
    disconnectConfig: { type: Object, default: () => {} },
    profilConfig: { type: Object, default: () => {} },
    searchConfig: { type: Object, default: () => {} },
    connectConfig: { type: Object, default: () => {} }
  },
  mounted() {
    document.body.addEventListener("mouseup", this.clickOutsideMenu);
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    toggleDropdownMenu(index) {
      if (index === this.shownDropdownMenuIndex)
        this.showDropdownMenu = !this.showDropdownMenu;
      else {
        this.shownDropdownMenuIndex = index;
        this.showDropdownMenu = true;
      }
    },
    clickOutsideMenu(event) {
      const target = event.target;
      const menu = document.querySelector(`#${this.navId}`);
      const toggler = document.querySelector(`#applicationHeader__mobile button.menutoggler`);
      if (menu && !menu.contains(target) && !toggler.contains(target))
        this.$nextTick(() => (this.showMenu = false));
    }
  },
  components: {
    EntiteServicielle,
    BlocPrive,
    MenuToggler,
    ApplicationMenu
  }
};
</script>
<style scoped>
.nav-link {
  cursor: pointer;
}
</style>